<div class="task-list-page">
  <div class="mobile-visible">
    <h2>Pipeline view not available on mobile</h2>
  </div>
  <div class="pipeline-width-too-narrow">
    <h2>The window is too narrow to display the pipeline view</h2>
  </div>
  <div class="top-section pipeline-width-visible">
    <div class="task-list-page-header-line">
      <div class="header-text">
        <h1>Pipeline</h1>
      </div>

      <div class="button-div">
        <button mat-icon-button aria-label="Filter" (click)="toggleFilter()">
          <mat-icon>filter_alt</mat-icon>
        </button>
        <button mat-icon-button aria-label="Search" (click)="openSearch()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>

    <app-filter-task-buttons *ngIf="showFilter"></app-filter-task-buttons>
  </div>

  <div class="bottom-section pipeline-width-visible">
    <div #listContainer class="list-container">
      <!-- Unassigned column -->
      <app-task-list
        *ngIf="optionalUnassignedBacklogColumn"
        [orgId]="orgId"
        [spaceId]="spaceId"
        [listId]="optionalUnassignedBacklogColumn.listId"
        [listFilter]="optionalUnassignedBacklogColumn.listFilter"
        [headerText]="'Backlog - Unassigned'"
        class="list-padding"
      ></app-task-list>
      <!-- Main backlog column -->
      <app-task-list
        [orgId]="orgId"
        [spaceId]="spaceId"
        [listId]="mainBacklogColumn.listId"
        [listFilter]="mainBacklogColumn.listFilter"
        [headerText]="'Backlog' + userHeaderText"
        class="list-padding"
      ></app-task-list>
      <!-- Current tasks -->
      <app-task-list
        [orgId]="orgId"
        [spaceId]="spaceId"
        [listId]="currentColumn.listId"
        [listFilter]="currentColumn.listFilter"
        [headerText]="'Current' + userHeaderText"
        class="list-padding"
      ></app-task-list>
    </div>
    <app-task-detail
      *ngIf="selectDisplayTaskId"
      [orgId]="orgId"
      [spaceId]="spaceId"
      [taskId]="selectDisplayTaskId"
      class="theme-background-color large-element-rounding"
    ></app-task-detail>
  </div>
</div>
